import { render, staticRenderFns } from "./collection-movements.vue?vue&type=template&id=1fe84b65&"
import script from "./collection-movements.vue?vue&type=script&lang=js&"
export * from "./collection-movements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports